import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion } from "framer-motion";

import Pagination from "../../../../../../ui/Pagination";
import NoDataFound from "../../../../../../ui/NoDataFound";
import SkeletonLoader from "../../../../../../ui/SkeletonLoader";

import SSLCertificate from "../../AssociatedDomain/SSLCertificate";

import { plusIcon, minusIcon } from "../../../../../../../utils/icons";

import { useSelector, useDispatch } from 'react-redux';
import { getSSLCertificate } from "../../../../../../../store/actions/scanInfoAction";

import apiEndpoints from "../../../../../../../apiEndpoints";

const PortInformation = ({sslData, domainId, scanId, currentPageType="ipAddress"}) => {

    const sslCertificateListResponse = useSelector((state) => state?.scanInfo.sslCertificateList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null)

    const dispatch = useDispatch();

    const [selecetedPortInfo, setSelectedPortInfo] = useState('');
    const [sslCertificateList, setSSLCertificateList] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);

    const selectPortInfo = (data) => {
        if(data === selecetedPortInfo) {
            setSelectedPortInfo("")
        } else {
            setSelectedPortInfo(data)
        }
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const fetchRecordData = useCallback(()=>{
        setIsLoading(true)
        if(currentPageType === "subdomain") {
            const url = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.subDomain.sslCertificate()}&page=${currentPage}&page_size=${currentPageSize}&subdomain=${sslData?.subdomain}&domain=${sslData?.domain}&scan_id=${sslData?.scan_id}`
            dispatch(getSSLCertificate(url))
        } else {
            const url = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.ipAddress.sslCertificate()}&page=${currentPage}&page_size=${currentPageSize}&ip_address=${sslData?.ip_address}&domain=${sslData?.domain}&scan_id=${sslData?.scan_id}`
            dispatch(getSSLCertificate(url))
        }
    },[dispatch, sslData, currentPageType, currentPage, currentPageSize])

    useEffect(()=>{
        if(sslData || domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            setCurrentPage(1);
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId;
        }
    },[domainId, scanId, sslData]);

    useEffect(()=>{
        fetchRecordData()
    },[currentPageSize, currentPage, fetchRecordData])
    
    useEffect(()=>{
        if(sslCertificateListResponse !== null) {
            setIsLoading(false)
            setSSLCertificateList(sslCertificateListResponse)
        }
    },[sslCertificateListResponse])

    return (
        <>
            {
                isLoading ? 
                <SkeletonLoader type={"line"} count={5} currentPage={"sslCertificate"} />
                :
                sslCertificateList !== "" && sslCertificateList?.results?.length > 0 &&
                sslCertificateList?.results?.map((data, index) => {
                    return (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <div className="port-information-container mb-3">
                                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{selectPortInfo(data?.port)}}>
                                    <h2 className="heading">Port: {data?.port}</h2>
                                    <div className="port-tag-container">                     
                                        {data?.self_signed && <span className="tag-content expired">Self Signed</span>}
                                        {data?.expired && <span className="tag-content expired">Expired</span>}
                                        {selecetedPortInfo === data?.port ? minusIcon() : plusIcon()}
                                    </div>                                               
                                </div>
                                {selecetedPortInfo === data?.port && 
                                    <div className="p-3">
                                        <SSLCertificate sslCertificateData={data}/>
                                    </div>
                                }
                            </div>
                        </motion.div>
                    )
                })
            }
            {
                !isLoading && sslCertificateList !== "" && sslCertificateList?.results?.length === 0 && 
                <NoDataFound noDataText={"No Record Found"}/>
            }
            {sslCertificateList !== "" && sslCertificateList?.results?.length > 0 && <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                pageSize={currentPageSize}
                totalCount={sslCertificateList?.meta?.total_results}
                onPageChange={setCurrentPageandRecordSize}
            />}
            
        </>
    )
}

export default PortInformation